import { Component, Input, OnInit } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';

@Component({
  selector: 'app-onboarding-placeholder',
  templateUrl: './onboarding-placeholder.component.html',
  styleUrls: ['./onboarding-placeholder.component.scss']
})
export class OnboardingPlaceholderComponent implements OnInit {
  @Input() svg?: string;
  @Input() placeholder?: string;
  @Input() buttons: { text: string; link: string }[] = [];
  @Input() noTitle = false;

  constructor(public rwdService: RWDService) {}

  ngOnInit(): void {}
}
